// import player from 'lottie-web/build/player/lottie_light';

export function playerFactory() {
  return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web/build/player/lottie_svg');
  // return player;
}
